import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const EditIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.573 0.0202247C17.3613 0.107641 18.1595 0.527444 18.8248 1.20238C20.2712 2.67118 20.3953 4.59638 19.1259 5.8873L18.8308 6.18614C18.8296 6.18672 18.8291 6.18761 18.8286 6.18864C18.8281 6.18944 18.8276 6.19034 18.8268 6.19123L16.9371 8.11236C16.9366 8.11294 16.936 8.11319 16.9356 8.11348C16.9353 8.11371 16.9351 8.11395 16.9351 8.11439C16.9341 8.11439 16.9341 8.11541 16.9331 8.11642L6.26258 18.6999L6.26158 18.7009C6.19056 18.7711 6.10353 18.8158 6.0135 18.8351L0.951817 19.9817C0.894798 19.9939 0.836779 20 0.77976 20C0.572691 20 0.372625 19.9166 0.223575 19.7611C0.0325119 19.5629 -0.042513 19.2824 0.0235089 19.014L1.27292 13.9002C1.29293 13.8107 1.33795 13.7253 1.40697 13.6552L1.40897 13.6531L1.40997 13.6521L12.0815 3.06761L13.9141 1.20441L14.2142 0.898457C14.8754 0.225552 15.6937 -0.0854884 16.573 0.0202247ZM18.4666 5.10665L14.9825 1.5673C15.4126 1.15562 15.9058 0.974692 16.465 1.02958C17.0272 1.0926 17.6133 1.40873 18.1175 1.92103C18.9098 2.72506 19.457 4.03224 18.4666 5.10665ZM16.587 7.03083L13.1349 3.43455L14.2702 2.28086L17.7664 5.83241L16.587 7.03083ZM2.46732 14.0242L5.92047 17.6194L15.8758 7.7444L12.4226 4.15015L2.46732 14.0242ZM1.07986 18.9114L2.02918 15.0234L4.92714 18.0402L1.07986 18.9114Z'
      />
    </svg>
  )
}
